/**
 * Centered column the artifact page header and sandbox share, so the render
 * surface leaves side margins instead of spanning the whole main pane.
 */
export const ARTIFACT_PAGE_MEASURE = 'mx-auto w-full max-w-6xl px-6'

/**
 * Sandbox width once the page column reaches its max measure (72rem minus the
 * two 1.5rem gutters). The inline chat preview lays its iframe out at this
 * width and scales it down, so the preview is a shrunken copy of the page.
 */
export const ARTIFACT_SANDBOX_WIDTH_PX = 1104
